module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-paymentsDetails"
  }, [(_vm.showPaymentOptions) ? _c('billing-address', {
    ref: "billingAddress"
  }) : _vm._e(), _vm._v(" "), (_vm.showPaymentOptions) ? _c('div', {
    staticClass: "o-paymentsDetails--form"
  }, [_c('div', {
    staticClass: "o-paymentsDetails--form__title"
  }, [_vm._v("Payment method*")]), _vm._v(" "), (_vm.hasStoredPaymentMethods) ? _c('SavedMethods', {
    ref: "savedMethod",
    attrs: {
      "paymentFlow": _vm.paymentFlow
    },
    on: {
      "selectPaymentMethod": _vm.selectSavedPaymentMethod
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasStoredPaymentMethods) ? _c('ToggleText', {
    class: 'o-paymentsDetails--form__toggle',
    attrs: {
      "faIconClass": _vm.showPaymentsMethod ? 'fas fa-minus' : 'fas fa-plus',
      "text": "Add new payment method"
    },
    on: {
      "toggleEditable": _vm.togglePaymentsMethod
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceData && _vm.showPaymentsMethod) ? _c('CreditCard', {
    ref: "CreditCard",
    attrs: {
      "clientInstance": _vm.clientInstance
    },
    on: {
      "openCreditCard": _vm.openCreditCard
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deviceData && _vm.showPaymentsMethod) ? _c('PayPal', {
    ref: "PayPal",
    attrs: {
      "clientInstance": _vm.clientInstance
    },
    on: {
      "paypalAuthorized": _vm.paypalAuthorized,
      "openPayPal": _vm.openPayPal
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "o-paymentsDetails--options"
  }, [(_vm.showPaymentOptions) ? _c('hr') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "a-Button--Large a-Button--Orange",
    attrs: {
      "id": "o-paymentsDetails--options__submit"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.showPaymentOptions ? 'Pay now' : 'Confirm')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.completeOrder.apply(null, arguments)
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-paymentsDetails--options__agreeMsg"
  }, [_vm._v("\n          By clicking the button below, you agree to Serato's\n          "), _c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "target": "_blank",
      "href": "/legal/terms-of-sale",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("terms and conditions")]), _vm._v("\n          and "), _c('a', {
    staticClass: "a-Link--Blue",
    attrs: {
      "target": "_blank",
      "href": "/legal/serato-privacy-policy",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("privacy policy.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72f5622a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/organisms/PaymentsDetails.vue
// module id = 537
// module chunks = 2